export const INSTANCE_TYPE = [
    {
        label: 'MyliaQ',
        value: 'Myliaq',
        color: '#00cc66',
    },
    {
        label: 'SeQoya',
        value: 'Seqoya',
        color: '#0066cc',
    },
    {
        label: 'IryQua',
        value: 'Iryqua',
        color: '#993366',
    },
    {
        label: 'AcycliQ',
        value: 'Acycliq',
        color: '#cc5200',
    },
    {
        label: 'SynaptiQ',
        value: 'Synaptiq',
        color: '#600080',
    },
    {
        label: 'MantiQ',
        value: 'Mantiq',
        color: '#b3b300',
    },
    {
        label: 'YdilliQ',
        value: 'Ydilliq',
        color: '#fffc61',
    },
    {
        label: 'Coclickeau',
        value: 'Coclickeau',
        color: '#ff6666',
    },
    {
        label: 'Aqua6BO-data',
        value: 'Aqua6BO-data',
        color: '#77ff33',
    },
    // {
    //     label: 'Aqua6BO-services',
    //     value: 'Aqua6BO-services',
    //     color: '#77ff33',
    // },
    // {
    //     label: 'Aqua6BO-licence',
    //     value: 'Aqua6BO-licence',
    //     color: '#77ff33',
    // },
    {
        label: 'IAeau',
        value: 'IAeau',
        color: '#333399',
    },
    {
        label: 'Infra',
        value: 'Infra',
        color: '#bdbdbd',
    },
]

export const UPTIME_GROUPS = {
    1: 'Site Web',
    3: 'Observatoires',
    5: 'Manager',
    25: 'Portail Agri',
    29: 'Store',
    62: 'Instance Test',
    63: 'Externe',
    97: 'Swagger',
}